import React, { useEffect, useState, useContext } from 'react';
import SearchContext from '../../state/context';

export const Pager = props => {
  const { controller, className } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState(controller.state);
  const { resultsListController } = useContext(SearchContext);

  useEffect(() => {
    controller.subscribe(() => {
      setState(controller.state);
    });
    resultsListController.subscribe(() => {
      setIsLoading(resultsListController.state.isLoading);
    });
  }, []);

  if (!state.hasNextPage && !state.hasPreviousPage) {
    return null;
  }

  return (
    <nav className={className}>
      <button
        disabled={!state.hasPreviousPage}
        onClick={() => controller.previousPage()}
        className={`pager-item pager-item--prev ${
          isLoading ? 'pager-item--loading' : ''
        }`}
      >
        <svg viewBox="0 0 11 18" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m9.7 1-8 8 8 8"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      </button>
      {state.currentPages.map(page => (
        <button
          className={`pager-item ${
            controller.isCurrentPage(page) ? 'pager-item--active' : ''
          } ${isLoading ? 'pager-item--loading' : ''}`}
          key={page}
          disabled={controller.isCurrentPage(page)}
          onClick={() => controller.selectPage(page)}
        >
          {page}
        </button>
      ))}
      <button
        disabled={!state.hasNextPage}
        onClick={() => controller.nextPage()}
        className={`pager-item pager-item--next ${
          isLoading ? 'pager-item--loading' : ''
        }`}
      >
        <svg viewBox="0 0 11 18" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m.7 1 8 8-8 8"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      </button>
    </nav>
  );
};
